import { pageViewTypes } from "@constants/tracking";
import StoreContainer from "@features/dashboard/screens/StoreContainer";
import useAnalytics from "@hooks/useAnalytics";
import { useAppStore } from "@hooks/useAppStore";
import DocumentTitle from "components/DocumentTitle";
import { Redirect, Stack } from "expo-router";
import { useMemo } from "react";
const StoreRoute = () => {
	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.store,
		};
	}, []);

	const isStoreEnabled = useAppStore((s) => s.store.enabled);
	useAnalytics(memoizedAnalyticsParams);

	if (!isStoreEnabled) {
		return <Redirect href="/(protected)/(tabs)/home" />;
	}

	return (
		<>
			<Stack.Screen
				options={{
					headerShown: false,
				}}
			/>
			<DocumentTitle title="Store" />
			<StoreContainer />
		</>
	);
};

export default StoreRoute;
